export const busca = {
  title: 'Search',
  description: 'Find tracks, courses, and lessons published on the platform.',
  placeholder: 'Search tracks, courses, and lessons…',
  prompt: {
    title: 'Type to search',
    description: 'Search covers the platform’s published content.',
  },
  semResultado: {
    title: 'No results',
    description: 'Check the spelling or try another term.',
  },
  tipo: {
    trilha: 'Track',
    curso: 'Course',
    aula: 'Lesson',
  },
} as const;
